import axios from "axios";

const getDeliveryDateFromUrl = (url, data) => {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "post",
      responseType: "html",
      data
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => reject(error));
  });
};

export default getDeliveryDateFromUrl;
